<div class="app-inline-dialog">
  <div class="app-inline-dialog__container">
    <mat-icon class="app-inline-dialog__icon">info_outline</mat-icon>
    {{ data.message }}
  </div>
  <div class="app-inline-dialog__close" (click)="close()">
    <mat-icon class="material-icons-outlined">close</mat-icon>
  </div>
</div>
